<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">
          {{ $t('wordSeparator.table.group') }}
        </th>
        <th scope="col" class="border-0">
          {{ $t('wordSeparator.table.repeatedWords') }}
        </th>
        <th scope="col" class="border-0">
          {{ $t('wordSeparator.table.totalWords') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in listMultipleCases" :key="index">
        <td>{{ `${$t('wordSeparator.table.group')} ${index + 1}` }}</td>
        <td class="td-2">{{ row.repeatedWords.join(', ') }}</td>
        <td class="td-3">
          {{ row.totalWord }}
        </td>
      </tr>
      <tr v-if="listMultipleCases.length === 0">
        <td colspan="3" class="no-content">
          {{ $t('wordSeparator.table.noContent') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'word-separator-list-table',
  props: {
    listMultipleCases: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-2 {
    min-width: 200px;
  }
  &-3 {
    min-width: 50px;
  }
}
</style>
